import { list as getList } from "~/api/userReferralUser.js";
import * as types from "../mutation-types";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";

export const state = {
  list: null,
  meta: null,
  isLoading: false,
  isInitialLoadPending: true
};

export const mutations = {
  [types.SET_IS_LOADING_USER_REFERRAL_USERS](state, status) {
    state.isLoading = status;
  },
  [types.SET_USER_REFERRAL_USERS](state, data) {
    state.list = data;
    state.isInitialLoadPending = false;
  },
  [types.SET_USER_REFERRAL_USERS_META](state, meta) {
    state.meta = meta;
  }
};

export const actions = {
  async fetchUserReferralUsers({ commit }) {
    commit(types.SET_IS_LOADING_USER_REFERRAL_USERS, true);

    try {
      const response = await getList();
      let { data } = response;
      commit(types.SET_USER_REFERRAL_USERS, data.data);
      commit(types.SET_USER_REFERRAL_USERS_META, data.meta);
    } catch (e) {
      console.error('Error fetching user referral users:', e);
    } finally {
      commit(types.SET_IS_LOADING_USER_REFERRAL_USERS, false);
    }
  }
};

export const getters = {
  list: (state) => state.list,
  meta: (state) => state.meta,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  ...entityStoreStatus.getters
};
